import { useEffect, useRef } from "react";

const gImg = (id) => `${process.env.REACT_APP_GDRIVE_IMG_BASE}/${id}=s200`;

const INSTITUTIONS = [
  { name: "Acharya College", img: gImg("1wGmByQchmEbucvVeVI76QkAnnT6QV6EZ") },
  { name: "Agragami BBA", img: gImg("1fp9nAQ3MUBaOtu63eVVg6tLuMamtQjZ1") },
  { name: "Agragami College", img: gImg("1FB9rrC-tMMxehDYmp2rDD6Bp-j0lGqfP") },
  { name: "AJK College", img: gImg("1leU6UUTEgLkNd-1N-mekw2czjP0-h9cg") },
  { name: "Bangalore International Academy", img: gImg("1-tDJNsHp1cspVYP_RJtaTYZcoisgxVzJ") },
  { name: "Bishop Cotton Girls'", img: gImg("1rLxcgC-saNz3wEmMGoS5YFi0BVFkJFuL") },
  { name: "Brandcrew Aviation", img: gImg("13mU_ET1Ey5ON1iGn8hU8j-MK02P_hLWu") },
  { name: "Deccan International School", img: gImg("1JJvb1fN7wDNMslf0a_3upxbtDuVVCNlr") },
  { name: "Frank Antony Public", img: gImg("1V86rpfUN2w0Jw82uzhvlufi0YW7S0eMI") },
  { name: "HAPS Aviation", img: gImg("13nH2Wzr3iHg8iKBVdJT9w3lHSJ8q2m4c") },
  { name: "Harrow International", img: gImg("1rLxcgC-saNz3wEmMGoS5YFi0BVFkJFuL") },
  { name: "Harsha Institute", img: gImg("1wGmByQchmEbucvVeVI76QkAnnT6QV6EZ") },
  { name: "Harvest International School", img: gImg("1fp9nAQ3MUBaOtu63eVVg6tLuMamtQjZ1") },
  { name: "Hindustan College", img: gImg("1FB9rrC-tMMxehDYmp2rDD6Bp-j0lGqfP") },
  { name: "Maple Bear", img: gImg("1leU6UUTEgLkNd-1N-mekw2czjP0-h9cg") },
  { name: "Mount Carmel", img: gImg("1-tDJNsHp1cspVYP_RJtaTYZcoisgxVzJ") },
  { name: "Oasis International School", img: gImg("13mU_ET1Ey5ON1iGn8hU8j-MK02P_hLWu") },
  { name: "Remo College", img: gImg("1JJvb1fN7wDNMslf0a_3upxbtDuVVCNlr") },
  { name: "REVA Institute", img: gImg("1V86rpfUN2w0Jw82uzhvlufi0YW7S0eMI") },
  { name: "RL Jalappa Poly", img: gImg("13nH2Wzr3iHg8iKBVdJT9w3lHSJ8q2m4c") },
  { name: "Spacetrix Aerospace", img: gImg("1rLxcgC-saNz3wEmMGoS5YFi0BVFkJFuL") },
  { name: "St. Vincent Palloti", img: gImg("1wGmByQchmEbucvVeVI76QkAnnT6QV6EZ") },
  { name: "Vervve Aviation", img: gImg("1fp9nAQ3MUBaOtu63eVVg6tLuMamtQjZ1") },
  { name: "Vivero International Schools", img: gImg("1FB9rrC-tMMxehDYmp2rDD6Bp-j0lGqfP") },
];

export default function InstitutionsSection() {
  const ref = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) entry.target.classList.add("visible"); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const doubled = [...INSTITUTIONS, ...INSTITUTIONS];

  return (
    <section id="institutions" data-testid="institutions-section" ref={ref} className="reveal-section py-16 md:py-20 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12 mb-8">
        <div className="text-center">
          <p className="text-xs tracking-[0.2em] uppercase font-semibold text-accent mb-3">Trusted Partners</p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-foreground mb-3">
            Institutions That Trust Us
          </h2>
          <p className="text-base text-muted-foreground font-light">
            Leading schools and institutions across Karnataka and beyond.
          </p>
        </div>
      </div>

      {/* Marquee - single line, bigger thumbnails, moving left to right */}
      <div className="relative">
        <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-background to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-background to-transparent z-10" />
        <div className="flex animate-marquee whitespace-nowrap py-4">
          {doubled.map((inst, i) => (
            <div key={i} className="flex flex-col items-center mx-6 shrink-0" data-testid={i < INSTITUTIONS.length ? `institution-${i}` : undefined}>
              <div className="w-20 h-20 rounded-full overflow-hidden border-2 border-border/60 bg-white shadow-sm mb-2">
                <img
                  src={inst.img}
                  alt={inst.name}
                  className="w-full h-full object-cover"
                  loading="lazy"
                  onError={(e) => { e.target.style.display = 'none'; }}
                />
              </div>
              <span className="text-xs text-center text-muted-foreground font-light whitespace-nowrap">
                {inst.name}
              </span>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-4 text-center">
        <p className="text-sm text-muted-foreground font-light italic">
          ...and many more institutions across Karnataka
        </p>
      </div>
    </section>
  );
}
